var map = {
	"./mountain-badge--dark.svg": 927,
	"./mountain-badge--light.svg": 928,
	"./surf-badge--dark.svg": 929,
	"./surf-badge--light.svg": 930,
	"./tide-badge--dark.svg": 931,
	"./tide-badge--light.svg": 932,
	"./weather-badge--dark.svg": 933,
	"./weather-badge--light.svg": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926;